/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Team_Stack_WithoutInputs */



/**
* | output |
* | --- |
* | "Show the colleagues without conversation info" |
*
* @param {Team_Stack_WithoutInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const team_stack_without = /** @type {((inputs?: Team_Stack_WithoutInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Team_Stack_WithoutInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Toon de collega's zonder gespreksinfo")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Afficher les collègues sans infos d'entretien")
	return /** @type {LocalizedString} */ ("Show the colleagues without conversation info")
});